import { render, staticRenderFns } from "./AiTemplatePrompt.vue?vue&type=template&id=1575c220&scoped=true"
import script from "./AiTemplatePrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiTemplatePrompt.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AiTemplatePrompt.vue?vue&type=style&index=0&id=1575c220&prod&scoped=true&lang=css"
import style1 from "./AiTemplatePrompt.vue?vue&type=style&index=1&id=1575c220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1575c220",
  null
  
)

export default component.exports